import dayjs, { Dayjs } from "dayjs";

export const getDaysDiffNewAccount = (firstDate: Dayjs) => {
  let today = dayjs();
  return 14 - today.diff(firstDate, "days");
};
